<template>
  <div>
    <!-- Modal Details -->
    <Modal v-model="visibilityStates.readVisibility" action="Sim" title="Tem certeza que deseja confirmar o pagamento?" @closeModal="visibilityStates.readVisibility = false" @confirmAction="patchWithdrawal(userId)"> </Modal>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <h4 slot="header" class="card-title">
            Saques
            <TotalRegisters :total="withdrawalsTableData.total" totalText="saques pendentes" />
          </h4>

          <Table :tableData="withdrawalsTableData" :data="withdrawals" :columns="['id', 'bank', 'createdAt', 'email', 'status', 'actions']" :actions="['patch']" @pagechanged="onPageChange" @openDetailsModal="openDetailsModal"> </Table>
          <ListLoader v-if="withdrawalsTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!withdrawalsTableData.loading && withdrawalsTableData.error"></Error>
          <Empty v-if="!withdrawalsTableData.loading && !withdrawalsTableData.error && withdrawals.length === 0"></Empty>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/Common/Table';
import Search from '@/components/Common/Search';
import { RepositoryFactory } from '../RepositoryFactory';
const withdrawals = new RepositoryFactory('withdrawal');
import TotalRegisters from '@/components/Common/TotalRegisters';
import Modal from '@/components/Modal/Modal';
import Empty from '@/components/Common/Empty';
import Pagination from '@/components/Pagination/Pagination';

export default {
  components: {
    Pagination,
    Modal,
    TotalRegisters,
    Search,
    Table,
    Empty,
  },
  data() {
    return {
      userId: null,
      // Modal States
      visibilityStates: {
        readVisibility: false,
      },
    };
  },
  computed: {
    withdrawals() {
      return this.$store.getters['withdrawals/getWithdrawals'];
    },
    withdrawalsTableData() {
      return this.$store.getters['withdrawals/getWithdrawalsTableData'];
    },
    withdrawal() {
      return this.$store.getters['withdrawals/getWithdrawal'];
    },
  },
  methods: {
    patchWithdrawal: async function(id) {
      await this.$store.dispatch('withdrawals/patchWithdrawal', id);
      this.visibilityStates.readVisibility = false;
      this.userId = null;
    },
    openDetailsModal: async function(id) {
      this.userId = id;
      // await this.$store.dispatch('withdrawals/getWithdrawalById', id);
      this.visibilityStates.readVisibility = true;
    },
    onPageChange(page) {
      this.$store.dispatch('withdrawals/setPage', page);
    },
  },
  mounted() {
    this.$store.dispatch('withdrawals/getWithdrawals');
  },
};
</script>
